import Vue from 'vue';
import Router from 'vue-router';

import Home2 from '@/pages/Home2.vue';
import About from '@/pages/About.vue';
import Error from '@/pages/Error.vue';
import Register from '@/pages/Register.vue';
import Signin from '@/pages/Signin.vue';
import TermsAndConditions from '@/pages/TermsAndConditions.vue';
import Policies from '@/pages/Policies.vue';
import DataTreatment from '@/pages/DataTreatment.vue';
import Blog from '@/pages/Blog.vue';
import Contact from '@/pages/Contact.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home Two',
      component: Home2,
    },
    {
      path: '/about',
      name: 'About Us',
      component: About,
    },
    {
      path: '/404',
      name: '404 Not Found',
      component: Error,
    },
    {
      path: '/sign-up',
      name: 'Sign Up',
      component: Register,
    },
    {
      path: '/sign-in',
      name: 'Sign In',
      component: Signin,
    },
    {
      path: '/TermsAndConditions',
      name: 'TermsAndConditions',
      component: TermsAndConditions,
    },
    {
      path: '/DataTreatment',
      name: 'DataTreatment',
      component: DataTreatment,
    },
    {
      path: '/Policies',
      name: 'Policies',
      component: Policies,
    },
    {
      path: '/blog',
      name: 'Blog',
      component: Blog,
    },
    {
      path: '/contact-us',
      name: 'Contact Us',
      component: Contact,
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
      };
    } else {
      return { x: 0, y: 0 };
    }
  }
});





// WEBPACK FOOTER //
// ./src/router/index.js